<template>
    <div v-bind:class="{'notedited': !editedsubstance['edit'] , 'collapsible-body': editedsubstance['id']}">
        <div class="row" style="width: 100%;">
            <div class="col s2" style="margin-bottom: 30px;">
                <template v-if="editedsubstance.image != null && editedsubstance.image != undefined">
                    <v-lazy-image v-bind:src="editedsubstance.image" src-placeholder="/nofoto.png" width="200" v-on:error="imageLoadError(editedsubstance)" />
                </template>
                <template v-else>
                    <img src="/nofoto.png" style="width: 64px;"/>
                </template>
                <input type="file" id="input" @change="setImageFile(editedsubstance, $event.target.name, $event.target.files)" v-if="editedsubstance.edit">
            </div>
            <div class="col s9">
                <div class="row" style="width: 100%;">
                    <div div class="col s1 rightlabel">{{$t('substances.name')}}</div>
                    <div div class="col s5">
                        <div class="input-field inline"><input :id="'substancename'+(editedsubstance.id || 'new')" type="text" :placeholder="$t('substances.name')" v-model="editedsubstance.name" :disabled="editedsubstance.edit == false" /></div>
                    </div>
                    <div div class="col s2 rightlabel">{{$t('substances.permission')}}</div>
                    <div div class="col s4">
                        <div class="input-field inline"><input :id="'substancepermission'+(editedsubstance.id || 'new')" type="text" :placeholder="$t('substances.permission')" v-model="editedsubstance.permission" :disabled="editedsubstance.edit == false" /></div>
                    </div>
                </div>
                <div class="row" style="width: 100%;">
                    <div div class="col s1 rightlabel">{{$t('substances.group')}}</div>
                    <div class="col s3">
                        <div class="input-field inline">
                            <selector v-model="editedsubstance.substance_group_ids" :items="substance_groups" :identifier="'editedsubstancegroupselectorfor'+editedsubstance.id" :disabled="editedsubstance.edit == false"/>
                        </div>
                    </div>
                    <div class="col s3"> 
                        <label>
                        <input type="checkbox" class="browser-default" name="plant_care" v-model="editedsubstance.plant_care" :disabled="editedsubstance.edit == false"/>
                        <span style="color: black;">{{$t('substances.plantcare')}}</span>
                        </label>
                    </div>
                    <div class="col offset-s1 s4"> 
                        <label>
                        <input type="checkbox" name="usage_discontinued" v-model="editedsubstance.usage_discontinued" :disabled="editedsubstance.edit == false" />
                        <span style="color: black;">{{$t('substances.withdrawn')}}</span>
                    </label>
                    </div>
                </div>
                <div class="row" style="width: 100%;">
                    <div class="col s1 rightlabel"> {{$t('substances.tags')}}</div>
                    <div class="col s3">
                        <div class="input-field inline"><input :id="'substancetags'+(editedsubstance.id || 'new')" type="text" :placeholder="$t('substances.tags')" v-model="editedsubstance.tags" :disabled="editedsubstance.edit == false" /></div>
                    </div>
                </div>
            </div>

            <div class="col s1">
                <modal v-if="editedsubstance.removable" :question="$t('substances.remove_substance_question')" :confirmText="$t('menu.buttons.delete')" identifier="substanceRemoveQuestion" v-on:onConfirm="removeSubstance(editedsubstance)" />
            </div>
        </div>
        <div class="row" style="width: 100%;">
            <div class="col s6">
                <div class="row">
                    <div class="col s4">
                        <div class="label">{{$t('substances.unit')}}</div>
                    </div>
                    <div class="col s6">
                    <select :id="'substanceunit'+(editedsubstance.id || 'new')" v-model="editedsubstance.default_unit" :disabled="editedsubstance.edit == false">
                        <option value="g">{{$t('substances.unit_g')}}</option>
                        <option value="ml">{{$t('substances.unit_ml')}}</option>
                        <option value="szt">{{$t('substances.unit_szt')}}</option>
                        <option value="package">{{$t('substances.unit_package')}}</option>
                        <option value="kpl">{{$t('substances.unit_kpl')}}</option>
                    </select>
                </div>
                </div>
                <div class="row">
                        <div class="col s4">
                            <div class="label">{{$t('substances.dosage')}}</div>
                        </div>
                        <div class="col s6">
                            <label>
                                <input type="checkbox" name="solution" v-model="editedsubstance.solution" :disabled="editedsubstance.edit == false" />
                                <span style="color: black;">{{$t('substances.solution')}}</span>
                            </label>
                    </div>
                </div>
                 <editable :placeholder="$t('substances.dosage')" v-if="editedsubstance.dosage != undefined" v-model="editedsubstance.dosage" :disabled="editedsubstance.edit == false"></editable>
                <div class="label" style="margin-top: 2rem;">{{$t('substances.dosage_variants')}}</div>
                <div class="row variants" style="width: 100%;" v-for="(dv, index) in editedsubstance.dosage_variants" :class="{ hide: dv.destroy, first: index == 0 }">
                    <div class="col s12 label">{{$t('substances.description')}}</div>
                    <div class="col s10">
                        <div class="input-field inline"><editable v-model="dv.description" :disabled="editedsubstance.edit == false"/></div>
                    </div>
                    <div class="col s2">
                        <a class="waves-effect waves-light btn-small red" v-on:click="removeDosageVariant(dv)" v-if="editedsubstance.edit">{{$t('menu.buttons.delete')}}</a>
                    </div>
                    <div class="dv col s4">
                        <autosizelabel :text="$t('substances.substance_quantity')"/>
                        <div class="input-field inline col"><input :id="'substdosvarquantity'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.dosage" :disabled="editedsubstance.edit == false" /></div>
                    </div>
                    <div class="dv col s3">
                        <select :id="'substdosvarkind'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.kind" :disabled="editedsubstance.edit == false">
                            <option value="percent">{{$t('substances.kinds.percent')}}</option>
                            <option value="grams">{{$t('substances.kinds.grams')}}</option>
                            <option value="kg">{{$t('substances.kinds.kg')}}</option>
                            <option value="liters">{{$t('substances.kinds.liters')}}</option>
                            <option value="mls">{{$t('substances.kinds.mls')}}</option>
                            <option value="ppm">{{$t('substances.kinds.ppm')}}</option>
                            <option value="pc">{{$t('substances.kinds.pc')}}</option>
                        </select>
                        <autosizelabel :text="$t('substances.per')" style="margin: 5px; line-height: 1;" />
                        <div class="input-field inline"><input :id="'substdosvarsolv'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.solution_volume" :disabled="editedsubstance.edit == false" /></div>
                    </div>
                    <div class="dv col s2">
                        <select :id="'substdosvarsolu'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.solution_unit" :disabled="editedsubstance.edit == false">
                            <option value="g">{{$t('substances.solution_units.g')}}</option>
                            <option value="kgrams">{{$t('substances.solution_units.kgrams')}}</option>
                            <option value="ml">{{$t('substances.solution_units.ml')}}</option>
                            <option value="m3">{{$t('substances.solution_units.m3')}}</option>
                            <option value="m2">{{$t('substances.solution_units.m2')}}</option>
                            <option value="pcs">{{$t('substances.solution_units.pcs')}}</option>
                            <option value="l">{{$t('substances.solution_units.l')}}</option>
                        </select>
                    </div>
                    <div class="dv col s3">
                        <select :id="'substdosvarperwhat'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.per_what" :disabled="editedsubstance.edit == false">
                            <option value="mixture">{{$t('substances.per_whats.mixture')}}</option>
                            <option value="water">{{$t('substances.per_whats.water')}}</option>
                            <option value="device">{{$t('substances.per_whats.device')}}</option>
                            <option value="surface">{{$t('substances.per_whats.surface')}}</option>
                            <option value="room">{{$t('substances.per_whats.room')}}</option>
                        </select>
                    </div>
                    
                </div>
                <div class="row variants last" style="width: 100%;" :class="{ first: editedsubstance.dosage_variants.length == 0 }">
                    <div class="col s5" style="margin-top: 2rem;">
                        <a class="waves-effect waves-light btn-small green" v-on:click="addDosageVariant()" v-if="editedsubstance.edit">
                            {{$t('substances.add_dosage_variant')}}
                        </a>
                    </div>
                </div>
            </div>
            <div class="col s6">
                <div class="label">{{$t('substances.devtypes')}}</div>
                <selector v-model="editedsubstance.dev_type_ids" :items="devtypesItems" :identifier="'dts'+editedsubstance.id" :elongating=true :disabled="editedsubstance.edit == false"></selector>
                <div class="label">{{$t('substances.usage_dangers')}}</div>
                <div class="input-field inline" style="margin-bottom: 10px;">
                    <editable :placeholder="$t('substances.usage_dangers')" v-model="editedsubstance.dangers" :disabled="editedsubstance.edit == false"></editable>
                </div>
                <div class="label">{{$t('substances.required_recommendations')}}</div>
                <div class="row" style="width: 100%;" v-for="(dv, index) in editedsubstance.required_intervention_recommendations" :class="{ hide: dv.destroy }">
                    <div class="col s3">
                        <div class="input-field inline">
                            <select  :id="'substrecokind'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.kind" :disabled="editedsubstance.edit == false">
                                <option value="evaporate">{{$t('substances.evaporate')}}</option>
                                <option value="exposition">{{$t('substances.exposition')}}</option>
                                <option value="ventillation">{{$t('substances.ventillation')}}</option>
                                <option value="opened">{{$t('substances.opened')}}</option>
                                <option value="other">{{$t('substances.other')}}</option>
                            </select></div>
                    </div>
                    <div class="col s6">
                        <div class="input-field inline"><input :id="'substrecovalue'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.value" :disabled="editedsubstance.edit == false"></div>
                    </div>
                    <div class="col s3">
                        <div class="input-field inline" style="width: initial;padding-bottom: 0px;">
                            <select :id="'substrecounit'+index+'of'+(editedsubstance.id || 'new')" v-model="dv.unit" :disabled="editedsubstance.edit == false">
                              <option value="min">{{$t('substances.min')}}</option>
                              <option value="hours">{{$t('substances.hours')}}</option>
                              <option selected="selected" value="days">{{$t('substances.days')}}</option>
                            </select></div>
                        <a class="waves-effect waves-light btn-small red" v-on:click="removeRecommendation(dv)" v-if="editedsubstance.edit" style="padding-bottom: 10px; margin-bottom: 8px; margin-left: 2px;">{{$t('menu.buttons.delete')}}</a>
                    </div>
                </div>
                <div class="row" style="width: 100%; margin-bottom: 15px !important;">
                    <div class="col s5">
                        <a class="waves-effect waves-light btn-small green" v-on:click="addRecommendation()" v-if="editedsubstance.edit">{{$t('substances.add_recommendation')}}</a>
                    </div>
                </div>
                <div class="label">{{$t('substances.additional_data')}}</div>
                <div class="input-field inline">
                    <editable :placeholder="$t('substances.additional_data_placeholder')" v-model="editedsubstance.additional_data" :disabled="editedsubstance.edit == false"></editable>
                </div>
            </div>
        </div>
        <div class="row" style="width: 100%;">
            <div class="col s12">
                <div class="label">{{$t('substances.documents_title')}}</div>
            </div>
        </div>
        <div class="row" style="width: 100%;">
            <div class="col s12" style="border: solid 0px;padding: 5px; margin: 5px;">
                <div class="row" style="width: 100%;" v-for="(doc, index) in editedsubstance.documents" :class="{ hide: doc.destroy }">
                    <div class="col s3">
                        <div class="input-field inline"><input :id="'substdocdescription'+index+'of'+(editedsubstance.id || 'new')" v-model="doc.description" :disabled="editedsubstance.edit == false" :placeholder="$t('substances.document_description_placeholder')" /></div>
                    </div>
                    <div class="col s3">
                        <div class="input-field inline"><input  :id="'substdocdate'+index+'of'+(editedsubstance.id || 'new')" type="date" v-model="doc.date" :placeholder="$t('substances.document_date_placeholder')" :disabled="editedsubstance.edit == false" /></div>
                    </div>
                    <div class="col s2">
                        <select  :id="'substdoctype'+index+'of'+(editedsubstance.id || 'new')" class="form-control" v-model="doc.doctype" :disabled="editedsubstance.edit == false">
                            <option value="characteristic">{{$t('substances.documents.characteristic')}}</option>
                            <option value="etiquete">{{$t('substances.documents.etiquete')}}</option>
                            <option value="permission">{{$t('substances.documents.permission')}}</option>
                            <option value="other">{{$t('substances.documents.other')}}</option>
                        </select>
                    </div>
                    <div class="col s3">
                        <a :href="doc.attachment.url" v-if="doc.attachment"><i class="material-icons dp48">insert_drive_file</i></a>
                        <input type="file" id="input" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="editedsubstance.edit">
                    </div>
                    <div class="col s1"><a class="waves-effect waves-light btn-small red" v-on:click="removeDocument(doc)" v-if="editedsubstance.edit">{{$t('menu.buttons.delete')}}</a></div>
                </div>
                <div class="row" style="width: 100%;">
                    <div class="col s3">
                        <a class="waves-effect waves-light btn-small green" v-on:click="addDocument()" v-if="editedsubstance.edit">{{$t('substances.document_add')}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 16px;">
            <div class="col offset-l10 s4 l2" v-if="editedsubstance.edit == false && editedsubstance.editable" style="text-align: right;"><a class="waves-effect waves-light btn-large emptygreen" v-on:click="editSubstance(editedsubstance)">{{$t('menu.buttons.edit')}}</a></div>
            <div class="col  offset-l8 s4 l2" v-if="editedsubstance.edit" style="text-align: right;"><a class="waves-effect waves-light btn-large cancelbutton" v-on:click="unEditSubstance(editedsubstance)"> {{$t('menu.buttons.cancel_changes')}}</a></div>
            <div class="col l2 s4" v-if="editedsubstance.edit" style="text-align: right; "><a style="width: 100%;" class="waves-effect waves-light btn-large emptygreen" v-on:click="saveSubstance(editedsubstance)">
                    <div v-if="saving" class="preloader-wrapper small active">
                        <div class="spinner-layer spinner-red-only">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="gap-patch">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    data: function() {
        return {
            order: 1,
            orderby: 'number',
            customers: [],
            saving: false,
            photo_changed: false,
            old_substance: {},
            editedsubstance: {
                dosage_variants: [],
                edit: false
            }
        }
    },
    props: { substance: Object, index: Number, substance_groups: Array, devtypes: Array },
    created() {
        var i = 0;
        for (var reco of this.substance.documents) {
            reco.destroy = false;
            if (reco.date == null) reco.date = moment(reco.created_at).format("YYYY-MM-DD");
        }
        if (this.substance.media.length == 0) {
            this.substance.media = []
            this.substance.media.push({ "image": "" });
        }
    },
    mounted(){
        var elems = document.querySelectorAll('.modal');
        var instances = M.Modal.init(elems, {});
        this.editedsubstance = _.cloneDeep(this.substance);
    },
    methods: {

        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 1) {
                    this.order = 0
                } else if (this.order == 0) {
                    this.order = 1
                }

            } else {
                this.orderby = order;
            }
        },
        editSubstance: function(substance) {
            this.old_substance = _.cloneDeep(substance);
            substance.edit = true;
            this.$forceUpdate();
        },
        unEditSubstance: function(substance) {
            if(substance.id != undefined){
                Object.assign(substance, this.old_substance);
                substance.edit = false;
                this.$forceUpdate();
            }else{
                this.$emit('cancelSubstance', substance);
            }
        },
        saveSubstance: function(substance) {
            const formData = new FormData();
            for (var key of Object.keys(substance)) {
                if(_.isArray(substance[key])){
                    for (var element of substance[key]) {
                        formData.append('substance[' + key + '][]', element);
                    }
                }else{
                    formData.append('substance[' + key + ']', substance[key]);
                }
            }
            var i = 0;
            for (var reco of substance.required_intervention_recommendations) {
                for (var key of Object.keys(reco)) {
                    formData.append('substance[required_intervention_recommendations_attributes][' + i + '][' + key + ']', reco[key]);
                }
                if (reco.destroy) {
                    formData.append('substance[required_intervention_recommendations_attributes][' + i + '][_destroy]', true);
                }
                i += 1;
            }
            var i = 0;
            if(this.photo_changed){
                for (var reco of substance.media) {
                    for (var key of Object.keys(reco)) {
                        formData.append('substance[media_attributes][' + i + '][' + key + ']', reco[key]);
                    }
                    if (reco.destroy) {
                        formData.append('substance[media_attributes][' + i + '][_destroy]', true);
                    }
                    i += 1;
                }
            }
            var i = 0;
            for (var reco of substance.dosage_variants) {
                for (var key of Object.keys(reco)) {
                    formData.append('substance[dosage_variants_attributes][' + i + '][' + key + ']', reco[key]);
                }
                if (reco.destroy) {
                    formData.append('substance[dosage_variants_attributes][' + i + '][_destroy]', true);
                }
                i += 1;
            }
            var i = 0;
            for (var reco of substance.documents) {
                // reco.doctype = reco.doctype || "other";
                if(reco.changed || reco.destroy){
                    for (var key of Object.keys(reco)) {
                        formData.append('substance[document_assets_attributes][' + i + '][' + key + ']', reco[key]);
                    }
                    if (reco.destroy) {
                        formData.append('substance[document_assets_attributes][' + i + '][_destroy]', true);
                    }
                    i += 1;
                }
                
            }
            var that = this;
            this.saving = true;
            if (_.isUndefined(substance.id)) {

                axios.post('/substances.json', formData).then(response => {
                    substance.id = response.data.id;
                    this.$emit('addSubstance', response.data)
                    substance.edit = false;
                    this.saving = false;
                });
            } else {
                axios.put('/substances/' + substance.id + '.json', formData).then(response => {
                    substance.edit = false;
                    substance.documents = response.data.documents;
                    substance.dosage_variants = response.data.dosage_variants;
                    substance.required_intervention_recommendations = response.data.required_intervention_recommendations;
                    this.saving = false;
                    this.$emit('updateSubstance', response.data)
                });
            }
        },
        setFile: function(doc, name, file) {
            doc.attachment = file[0];
            doc.changed = true
        },
        setImageFile: async function(doc, name, file) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
            const result = await toBase64(file[0]).catch(e => Error(e));
            if (result instanceof Error) {
                console.log('Error: ', result.message);
                return;
            }
            doc.image = result;
            if(doc.media.length == 0) doc.media.push({image: ""});
            doc.media[0].image = file[0];
            this.photo_changed = true;
            this.$forceUpdate();
        },
        removeSubstance: function(substance) {
            this.$emit('removeSubstance', substance);
        },
        removeRecommendation: function(dv) {
            if (_.isUndefined(dv.id)) {
                this.editedsubstance.required_intervention_recommendations.splice(this.editedsubstance.required_intervention_recommendations.indexOf(dv), 1)
            } else {
                dv.destroy = true;
                this.$forceUpdate();
            }
        },
        addRecommendation: function() {
            this.editedsubstance.required_intervention_recommendations.push({})
        },
        setAltImg: function(event) {},
        removeDosageVariant: function(dv) {
            if (_.isUndefined(dv.id)) {
                this.editedsubstance.dosage_variants.splice(this.editedsubstance.dosage_variants.indexOf(dv), 1)
            } else {
                dv.destroy = true;
                this.$forceUpdate();
            }
        },
        addDosageVariant: function() {
            this.editedsubstance.dosage_variants.push({})
        },
        addDocument: function() {
            this.editedsubstance.documents.push({
                date: moment().format("YYYY-MM-DD"),
            })
        },
        removeDocument: function(doc) {
            if (_.isUndefined(doc.id)) {
                this.editedsubstance.documents.splice(this.editedsubstance.documents.indexOf(doc), 1)
            } else {
                doc.destroy = true;
                this.$forceUpdate();
            }
        },

        hasRemoveListener() {
            return this.$listeners && this.$listeners.removeSubstance
        },
        imageLoadError: function(substance){
            console.log(substance);
            this.editedsubstance.image = null;
            this.$forceUpdate();
        }

    },
    computed: {
        devtypesItems: function() {
            return _.map(this.devtypes, function(dt) {
                return { name: dt.name, value: dt.id };
            })
        },
    }
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 100px;
}

nav a {
    margin: 15px;
}

select {
    display: block;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.collapsible-header {
    background-color: #FFFFFF !important;
}

.solidgreen {
    background-color: #00CC66 !important;
}

.row {
    margin-bottom: 0px;
}
.col .row {
    margin-left: 0rem;
    margin-right: 0rem;
}
.input-field {
    margin-top: 0rem;
    margin-bottom: 0rem;
    padding-bottom: 10px;
}

.col>.input-field {
    width: 100%;
}
.row>.input-field {
    margin-top: 0px;
    margin-bottom: 5px;
}

.btn-small {
    color: black;
    border-radius: 8px;
}

.red {
    background-color: #C22026 !important;
    border-color: #C22026 !important;
}

select {
    display: block !important;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}
input[type="file"]{
    width: 80%;
}

.ti-input{
  min-height: 37px !important;
}
.vue-tags-input .ti-input{
    border-radius: 8px !important;
    padding-bottom: 5px !important;
    padding-top: 5px !important;
}   
.rightlabel {
    text-align: right;
    line-height: 2;
    text-transform: uppercase;
}
.label{
    text-transform: uppercase;
}
textarea{
    line-height: 1;
    padding: 0.25em;
}
.dv.col{
  display: flex;
  max-height: 60px;
}
.dv.col .col{
    padding: 0px;
}
.variants{
    border-left: solid 1px;
    border-right: solid 1px;
}
.variants.first{
    border-top: solid 1px;
    padding-top: 10px;
    border-top-left-radius: 4px !important;
    border-top-right-radius: 4px !important;
}
.variants.last{
    border-bottom: solid 1px;
    padding-bottom: 10px;
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
}
input[type='checkbox']{
    display: none;
}
</style>